import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { clearSession, getStoredUser, isLoggedIn } from "../api";

// The site is public (2026-09-20) - the nav always renders. The user/logout
// section only appears for an admin who's actually signed in; there's no
// reader login anymore, so anonymous visitors just see the nav links.
export default function Nav() {
  const navigate = useNavigate();
  const user = getStoredUser();
  const loggedIn = isLoggedIn();

  function handleLogout() {
    clearSession();
    navigate("/");
  }

  return (
    <nav className="nav">
      <div className="nav-brand">TechSprout</div>
      <div className="nav-links">
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/today">Today</NavLink>
        <NavLink to="/archive">Archive</NavLink>
        <NavLink to="/search">Search</NavLink>
      </div>
      <div className="nav-user">
        {loggedIn ? (
          <>
            <span>{user?.name}</span>
            <button onClick={handleLogout}>Log out</button>
          </>
        ) : (
          <NavLink to="/login">Admin</NavLink>
        )}
      </div>
    </nav>
  );
}
